import ConfirmModal from "server/components/Modals/ConfirmModal";
import { useNotify, useRefresh } from "react-admin";
import { Box } from "@mui/material";
import dataProvider from "server/dataProvider";

const ApproveModal = ({ request, titleContent, title, successMessage }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const handleSubmit = async () => {
    await dataProvider.customRequest(request, {}, "PUT");
    refresh();
    notify(successMessage, { type: "success" });
  };

  return (
    <Box
      display="flex"
      justifyContent="flex-end"
      alignItems={"center"}
      pb={1}
    >
      <ConfirmModal
        titleButton={title}
        btnStyle={{
          bgcolor: theme => theme.palette.success.main,
          "&:hover": {
            bgcolor: theme => theme.palette.success.dark,
          },
        }}
        titleContent={titleContent}
        onConfirm={handleSubmit}
      />
    </Box>
  );
};
export default ApproveModal;
